import { getFirebaseConfig, getRootConfig } from '../utilities/config';

interface FirebaseEnvConfig {
  firebaseApiKey: string;
  firebaseAuthDomain: string;
  firebaseAppId: string;
  firebaseProjectId: string;
  firebaseStorageBucket: string;
  firebaseMessagingSenderId: string;
  firebaseMeasurementId: string;

  sentryDSN: string;
}

let cachedFirebaseConfig: FirebaseEnvConfig | null = null;

export async function getFirebaseEnvConfig(): Promise<FirebaseEnvConfig> {
  if (cachedFirebaseConfig) {
    return cachedFirebaseConfig;
  }

  try {
    const { frontendConfigLink } = getRootConfig();

    const response = await fetch(frontendConfigLink);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const config = await response.json();
    cachedFirebaseConfig = config;
    return config;
  } catch (error) {
    console.error('Failed to fetch Firebase config:', error);
    return getFirebaseConfig() as FirebaseEnvConfig;
  }
}
